import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Type', prop: 'type' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const Categories = props => {
  const defaults = {
    order: [{ column: 'updated_at', direction: 'desc' }]
  }
  if (props.categoryType) {
// @ts-ignore
    defaults.filters = {
      type: props.categoryType
    }
  }
  return (
    <List
      title='Categories'
      apiPath='admin/categories'
      columns={columns}
      defaults={defaults}
      buildMenuItems={menuItems}
      locationPathname={props.location.pathname}
      locationSearch={props.location.search}
    />
  )
}

export default Categories
